module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg"
  }, [_c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon_msg",
    class: [_vm.success ? 'weui-icon-success' : 'weui-icon-warn']
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "weui-msg__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b6f5d81","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/public-lib/vue-components/src/components/c-msg/index.vue
// module id = 376
// module chunks = 0